// lib/http/common.js
import axios from 'axios'

export const createBaseService = (type) => {

    let baseURL = process.env.NEXT_PUBLIC_API_BASE;

    if (process.env.NODE_ENV === 'development' && type !== 'server') {
        baseURL = '/api';
    }

    return axios.create({
        baseURL,
        timeout: 15000
    })
}

export const applyDefaultParams = (config) => {
    config.params = {
        v: '1.0',
        ttid: 'h5#website_i18n@ywtpc',
        //  ttid: '1.0.0_i18n@yibuy',
        did: '0',
        ts: Date.now(),
        sign: 'sign',
        currency: "USD",
        lang: 'en',
        ...config.params
    }
    return config
}